export const iconFontAwesomeMoneyCediSign = (
	<i className="fa-solid fa-cedi-sign"></i>
);
